<template>
  <div class="app-product-information-sheets-v2">
    <dyn-slot>
      <slot name="txtBefore"></slot>
    </dyn-slot>
    <ProductInformationList :product-information-list="productInformationList">
      <template v-for="slot in possibleChildSlotsFor('List')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProductInformationList>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import transaction from '../../../../mixins/transaction'
import slotProxy from '../../../../mixins/slotProxy'
import ProductInformationList from './ProductInformationList.vue'
import { mapGetters } from 'vuex'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'ProductInformationSheetsWrapper',
  components: { ProductInformationList },
  data() {
    return {
      productInformations: {
        productInformationList: []
      }
    }
  },
  apollo: {
    productInformations: function() {
      return wrapQuery(
        gql`
          query productInformationSheets($brand: String!) {
            productInformations(brand: $brand) {
              productInformationList {
                active
                market
                pibName
                productIdentifier
                productName
                recentVersion {
                  documentReference
                  validFrom
                  validTo
                  version
                }
                historicVersions {
                  documentReference
                  validFrom
                  validTo
                  version
                }
                variant
              }
            }
          }
        `,
        this,
        'productInformations',
        { brand: this.brand }
      )
    }
  },
  mixins: [transaction('productInformationSheets'), slotProxy()],
  computed: {
    ...mapGetters(['brand']),
    productInformationList: function() {
      return this.productInformations.productInformationList
    }
  }
}
</script>
